import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'cohrex-skeleton-loader',
  templateUrl: './skeleton-loader.component.html',
  styleUrl: './skeleton-loader.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class SkeletonLoaderComponent {
  @Input()
  size: string = 'tw-h-2 tw-w-full';
  @Input()
  color: string = 'tw-bg-slate-400';
  @Input()
  rounded: string = 'tw-rounded';
}
